package com.siriusxm.pia.views.unifiedaggregator.services

import androidx.compose.runtime.*
import com.siriusxm.pia.components.*
import com.siriusxm.pia.views.unifiedaggregator.AggregatorApplication
import com.siriusxm.pia.views.unifiedaggregator.smithy.aggregatorSmithyEntityView
import com.siriusxm.unifiedcontent.cmc.GetServiceEntityPayload
import com.siriusxm.unifiedcontent.cmc.ServiceEntity
import com.siriusxm.unifiedcontent.entityTypeObj
import contentingestion.unifiedmodel.entityId
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.jsonObject
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.px

/**
 * A view of the entity's data as the services have it.
 */
@Composable
fun EntityServicesView(app: AggregatorApplication, atlasEntity: JsonObject) {
    /**
     * Map of service to region to entity
     */
    var entities by remember { mutableStateOf<List<ServiceEntity>?>(null) }
    var selectedService by remember { mutableStateOf<String?>(null) }
    var selectedRegion by remember { mutableStateOf<String?>(null) }
    var regions by remember { mutableStateOf<List<String>>(emptyList()) }
    var serviceIds by remember { mutableStateOf<List<String>>(emptyList()) }
    val appData by app.aggregatorContext()

    LaunchedEffect(entityId) {
        val result = app.cmcService.getServiceEntity(
            "all", region = "all", body = GetServiceEntityPayload(atlasEntity)
        )
        regions = result.map {
            it.region
        }.distinct()
        serviceIds = result.map {
            it.serviceId
        }.distinct()
        entities = result
    }

    waitUntilNonNull(entities) {
        Row(style = {
            gap(5.px)
            margin(5.px, 0.px)
        }) {
            simpleSelectNullable(selectedService, serviceIds.map { it to it }, "Select a service") {
                selectedService = it
            }
            simpleSelectNullable(selectedService, regions.map { it to it }, "Select a region") {
                selectedRegion = it
            }
        }

        if (selectedService != null && selectedRegion != null) {
            val selectedResponse = entities?.find {
                it.serviceId == selectedService && it.region == selectedRegion
            }
            if (selectedResponse != null) {
                val selectedEntity = selectedResponse.entity
                if (selectedEntity != null) {
                    val entityType = selectedEntity.entityTypeObj
                    if (entityType != null) {
                        aggregatorSmithyEntityView(appData!!, selectedEntity)
                    } else {
                        jsonView(selectedResponse.entity!!.jsonObject)
                    }
                } else {
                    messageBox(selectedResponse.errorReasons ?: "Unable to load entity")
                }
            }
        }
    }
}